import { useEffect } from 'react'

const BASE_URL = 'https://cercledesops.io'

/**
 * Met a jour les balises SEO dynamiques (canonical, og:url, twitter:url)
 * en fonction de la route courante.
 */
export function useSeo(pathname: string) {
  useEffect(() => {
    const fullUrl = pathname === '/' ? BASE_URL + '/' : BASE_URL + pathname

    // Canonical
    const canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null
    if (canonical) {
      canonical.href = fullUrl
    }

    // Open Graph URL
    const ogUrl = document.querySelector('meta[property="og:url"]') as HTMLMetaElement | null
    if (ogUrl) {
      ogUrl.content = fullUrl
    }

    // Twitter URL
    const twitterUrl = document.querySelector(
      'meta[property="twitter:url"]',
    ) as HTMLMetaElement | null
    if (twitterUrl) {
      twitterUrl.content = fullUrl
    }
  }, [pathname])
}
